import React, { Component } from 'react'
import ReactTable from 'react-table'
import './react-table.css'

export default class Summary extends Component {

  buildStnData = (qcresults) => {
    let rowData = []
    for (let stnId of Object.keys(qcresults)) {
        let below = 0, exceeds = 0, toolow = 0, toohigh = 0, dates = []
        for (let msg of qcresults[stnId]["messages"]) {
            if (!dates.includes(msg.date)) {
                dates.push(msg.date)
            }
            switch(msg.test) {
                case "newa BELOW range": {
                    below += msg.hours.length
                    break
                }
                case "newa EXCEEDS range": {
                    exceeds += msg.hours.length
                    break
                }
                case "newa too LOW": {
                    toolow += msg.hours.length
                    break
                }
                case "newa too HIGH": {
                    toohigh += msg.hours.length
                    break
                }
                default: {
                    break
                }
            }
        }
        rowData.push({
            state: qcresults[stnId]["state"],
            id: stnId, 
            msgcnt: dates.length,
            below: below,
            exceeds: exceeds,
            toolow: toolow,
            toohigh: toohigh
        })
    }
    return rowData
  }
    
  buildColumns = () => {
    return [
      {Header: <b>{this.props.qcVarName}</b>, columns: [
        {Header: 'State', accessor: 'state', width: 50, defaultSortDesc: false, filterMethod: (filter, row) =>
          row[filter.id].includes(filter.value.toUpperCase())
        },
        {Header: 'Station', accessor: 'id', width: 120, defaultSortDesc: false, filterMethod: (filter, row) =>
          row[filter.id].includes(filter.value.toLowerCase())
        }
      ]},
      {Header: 'Days', columns: [
        {Header: 'Flagged', accessor: 'msgcnt', width: 96, defaultSortDesc: true}
      ]},
      {Header: 'Hours Range', columns: [
        {Header: 'Below', accessor: 'below', width: 96, defaultSortDesc: true},
        {Header: 'Exceeds', accessor: 'exceeds', width: 96, defaultSortDesc: true},
      ]},
      {Header: 'Hours Difference', columns: [
        {Header: 'Too low', accessor: 'toolow', width: 96, defaultSortDesc: true},
        {Header: 'Too high', accessor: 'toohigh', width: 96, defaultSortDesc: true},
      ]}
    ]
  }

  render() {
    const stnList = this.buildStnData(this.props.qcresults)
    const cl = this.buildColumns()
    return (
      <div>
        <ReactTable 
          columns={cl} 
          data={stnList} 
          defaultSorted={[
            { id: "state" },
            { id: "id" }
          ]}
          filterable
          defaultFilterMethod={(filter, row) =>
            parseInt(row[filter.id],0) >= parseInt(filter.value,0)
          }
          showPagination={true} 
          defaultPageSize={25}
          style={{width:'650px'}}
          className={"-striped -highlight"}
          getTdProps={(state, rowInfo, column, instance) => {
            return {
              onClick: (e, handleOriginal) => {
                this.props.changeState({"stnId":rowInfo.row.id})
                if (handleOriginal) {
                  handleOriginal()
                }
              }
            };
          }}
        />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Summary.js